const footerLinks = [
  { label: '热播榜单', href: '#ranking' },
  { label: '焦点专题', href: '#carousel' },
  { label: '影视索引', href: '#index' },
  { label: '精选推荐', href: '#cards' },
  { label: '最新动态', href: '#updates' },
  { label: '常见问题', href: '#faq' },
  { label: '联系我们', href: '#contact' },
  { label: '关于我们', href: '#about' },
];

export default function Footer() {
  return (
    <footer id="footer" className="relative w-full bg-background-950 border-t border-background-300/20">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12">
          <div className="md:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-play-fill text-lg text-background-950"></i>
              </div>
              <span className="text-lg font-black text-foreground-100">香蕉影视</span>
            </div>
            <p className="text-sm text-foreground-500 leading-relaxed mb-4">
              香蕉影视提供高清免费在线观看，不缓冲秒开，最新热播电影、电视剧、综艺大全，全集免费在线看，高清流畅不卡顿。追剧必备的优质在线视频平台。
            </p>
            <div className="flex items-center gap-3">
              <a href="#hero" className="w-8 h-8 rounded-full bg-background-800/50 hover:bg-background-700 flex items-center justify-center transition-colors cursor-pointer">
                <i className="ri-wechat-line text-sm text-foreground-400"></i>
              </a>
              <a href="#hero" className="w-8 h-8 rounded-full bg-background-800/50 hover:bg-background-700 flex items-center justify-center transition-colors cursor-pointer">
                <i className="ri-weibo-line text-sm text-foreground-400"></i>
              </a>
              <a href="#hero" className="w-8 h-8 rounded-full bg-background-800/50 hover:bg-background-700 flex items-center justify-center transition-colors cursor-pointer">
                <i className="ri-bilibili-line text-sm text-foreground-400"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-bold text-foreground-200 text-sm mb-4">快速导航</h4>
            <div className="grid grid-cols-2 gap-2">
              {footerLinks.map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  className="text-sm text-foreground-500 hover:text-foreground-200 transition-colors py-1 cursor-pointer"
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-bold text-foreground-200 text-sm mb-4">合作伙伴</h4>
            <p className="text-sm text-foreground-600 leading-relaxed">
              更多优质合作伙伴即将入驻，敬请期待。
            </p>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-300/20 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-600">
            &copy; 2026 香蕉影视 版权所有 | 高清免费在线观看平台
          </p>
          <div className="flex items-center gap-4">
            <a href="#hero" className="text-xs text-foreground-600 hover:text-foreground-400 transition-colors cursor-pointer">服务条款</a>
            <a href="#hero" className="text-xs text-foreground-600 hover:text-foreground-400 transition-colors cursor-pointer">隐私政策</a>
            <a href="#hero" className="text-xs text-foreground-600 hover:text-foreground-400 transition-colors cursor-pointer">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}